import React from 'react';
import { useAuth } from '../../../shared/contexts/AuthContext';
import RippleButton from '../../common/RippleButton';

interface DashboardHeaderProps {
  title?: string;
  className?: string;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title = "Travel Portal Dashboard",
  className = ''
}) => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    // Redirect will be handled by the auth context and route protection
  };

  return (
    <div className={`dashboard-header ${className}`}>
      <h1 className="dashboard-title">{title}</h1>
      
      <div className="dashboard-header-right">
        <RippleButton
          className="btn-logout"
          onClick={handleLogout}
          variant="danger"
          size="small"
        >
          Log Off
        </RippleButton>
      </div>
    </div>
  );
};

export default DashboardHeader;